import { useState } from "react"
import { HiUpload } from "react-icons/hi";
import { IoClose, IoAdd } from "react-icons/io5";
import { FaRegTrashAlt } from "react-icons/fa";
import { IoIosAddCircleOutline } from "react-icons/io";
// import Barcode from 'react-barcode';

const AddProduct = () => {

    const [productPic, setProductPic] = useState([null])
    const [currentSizeType, setCurrentSizeType] = useState(sizeType.kg)
    const [sizeInput, setSizeInput] = useState([{ unit: '', stock: '', price: '' }])
    const [inputs, setInputs] = useState({ size_type: sizeType.kg })


    const handleInputChange = (e) => {
        const { name, value } = e.target
        setInputs({ ...inputs, [name]: value })
    }

    const handlePicChange = (e, index) => {
        const file = e.target.files[0];
        const { name, value } = e.target
        const reader = new FileReader();

        reader.onloadend = () => {
            const newImages = [...productPic];
            newImages[index] = reader.result;
            setProductPic(newImages);
        };

        if (file) {
            reader.readAsDataURL(file);
        }

        setInputs({ ...inputs, [name]: value })
    }

    const handleAddImage = () => {
        setProductPic([...productPic, null]);
    };

    const handleRemoveImage = (index) => {
        const newImages = productPic.filter((_, i) => i !== index);
        setProductPic(newImages);
    };

    const handleSizeTypeChange = (type) => {
        setCurrentSizeType(type)
        setSizeInput([{ unit: '', stock: '', price: '' }])
        setInputs({ ...inputs, size_type: type })
    }

    const handleSizeInputChange = (e, index) => {
        const { name, value } = e.target
        const onChangeVal = [...sizeInput]
        onChangeVal[index][name] = value
        setSizeInput(onChangeVal)
        setInputs({ ...inputs, size: sizeInput })
    }

    const addSizeInput = () => {
        setSizeInput([...sizeInput, { unit: '', stock: '', price: '' }])
    }

    const deleteSizeInput = (index) => {
        const delVal = [...sizeInput]
        delVal.splice(index, 1)
        setSizeInput(delVal)
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        console.log(inputs)
    }

    return (
        <div className=" p-4">
            <form onSubmit={handleSubmit} className=" w-full *:my-4" encType="multipart/form-data">
                <div className=" p-4 md:p-8 bg-white rounded-md shadow border-2 border-slate-300">
                    <div className=" pb-2 flex items-center *:flex-none gap-4 overflow-x-auto scrollbar small-scrollbar">
                        {
                            productPic.map((item, index) => (
                                <div key={index} className=" flex items-center">
                                    <div className=" w-[200px]">
                                        <div className=" w-full aspect-square rounded-md bg-gray-300 shadow-lg overflow-hidden">
                                            {item && <img src={item} className=" w-full h-full object-contain" alt="Not found" />}
                                        </div>
                                        <div className=" mt-4 flex gap-2">
                                            <label className=" flex-1 cursor-pointer active:scale-95 rounded-md py-2 flex items-center justify-center gap-2 bg-tripstore-black text-white" htmlFor={`img-${index}`}>
                                                <HiUpload />
                                                <span>Upload Image</span>
                                            </label>
                                            <input onChange={(e) => handlePicChange(e, index)} type="file" name={`img_${index}`} id={`img-${index}`} className=" hidden" />
                                            <div onClick={() => handleRemoveImage(index)} className=" cursor-pointer rounded-md border-2 border-red-500 px-3 text-red-500 hover:bg-red-500 hover:text-white flex justify-center items-center active:scale-95"><IoClose /></div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                        <div onClick={() => handleAddImage()} className=" w-[60px] h-[60px] rounded-full border-2 border-tripstore-black mx-8 cursor-pointer flex justify-center items-center text-3xl transition hover:rotate-180 hover:bg-tripstore-black hover:text-white active:scale-95"><IoAdd /></div>
                    </div>
                </div>
                <div className=" p-4 md:p-8 bg-white rounded-md shadow border-2 border-slate-300">
                    <div className=" flex flex-col md:flex-row gap-4 *:w-full">
                        <div className=" flex flex-col">
                            <label className=" text-sm font-semibold" htmlFor="p-name">Product Name</label>
                            <input type="text" name="product_name" id="p-name" onChange={handleInputChange} required />
                        </div>
                        <div className=" flex flex-col">
                            <label className=" text-sm font-semibold" htmlFor="p-category">Product Category</label>
                            <select name="product_category" id="p-category" onChange={handleInputChange} required>
                                <option value="">---</option>
                                <option value="health & beauty">Health & Beauty</option>
                                <option value="home & office">Home & Office</option>
                                <option value="appliances">Appliances</option>
                                <option value="phones & tablets">Phones & Tablets</option>
                                <option value="computing">Computing</option>
                                <option value="electronics">Electronics</option>
                                <option value="fashion">Fashion</option>
                                <option value="baby products">Baby Products</option>
                                <option value="gaming">Gaming</option>
                                <option value="sporting goods">Sporting Goods</option>
                                <option value="others">Others</option>
                            </select>
                        </div>
                    </div>
                    <div className=" mt-2 flex flex-col">
                        <label className=" text-sm font-semibold" htmlFor="p-desc">Product Description</label>
                        <textarea name="product_description" id="p-desc" onChange={handleInputChange} ></textarea>
                    </div>
                </div>
                <div className=" p-4 md:p-8 bg-white rounded-md shadow border-2 border-slate-300">
                    <div className=" text-sm font-semibold">Select Size Type</div>
                    <div className=" mt-2 flex flex-wrap gap-4 *:text-nowrap">
                        <div onClick={() => handleSizeTypeChange(sizeType.kg)} className={`${(currentSizeType === sizeType.kg) ? " bg-tripstore-black text-white" : " bg-gray-300 text-gray-800 hover:bg-tripstore-black hover:text-white"} py-1 px-3 rounded-md cursor-pointer active:scale-95`}>Kilograms (KG)</div>
                        <div onClick={() => handleSizeTypeChange(sizeType.litre)} className={`${(currentSizeType === sizeType.litre) ? " bg-tripstore-black text-white" : " bg-gray-300 text-gray-800 hover:bg-tripstore-black hover:text-white"} py-1 px-3 rounded-md cursor-pointer active:scale-95`}>Liters</div>
                        <div onClick={() => handleSizeTypeChange(sizeType.cloth)} className={`${(currentSizeType === sizeType.cloth) ? " bg-tripstore-black text-white" : " bg-gray-300 text-gray-800 hover:bg-tripstore-black hover:text-white"} py-1 px-3 rounded-md cursor-pointer active:scale-95`}>Cloth Size</div>
                        <div onClick={() => handleSizeTypeChange(sizeType.shoe)} className={`${(currentSizeType === sizeType.shoe) ? " bg-tripstore-black text-white" : " bg-gray-300 text-gray-800 hover:bg-tripstore-black hover:text-white"} py-1 px-3 rounded-md cursor-pointer active:scale-95`}>Shoe Size</div>
                        <div onClick={() => handleSizeTypeChange(sizeType.inches)} className={`${(currentSizeType === sizeType.inches) ? " bg-tripstore-black text-white" : " bg-gray-300 text-gray-800 hover:bg-tripstore-black hover:text-white"} py-1 px-3 rounded-md cursor-pointer active:scale-95`}>Inches</div>
                        <div onClick={() => handleSizeTypeChange(sizeType.capacity)} className={`${(currentSizeType === sizeType.capacity) ? " bg-tripstore-black text-white" : " bg-gray-300 text-gray-800 hover:bg-tripstore-black hover:text-white"} py-1 px-3 rounded-md cursor-pointer active:scale-95`}>Capacity</div>
                    </div>
                    <div className=" mt-4">
                        {
                            (currentSizeType === sizeType.kg) &&
                            <div className="">
                                <table className=" w-full">
                                    <thead>
                                        <tr className=" text-sm font-semibold text-gray-500 border-b-2 border-slate-300">
                                            <td>Unit (KG)</td>
                                            <td>Price (&#8358;)</td>
                                            <td>Stock</td>
                                            <td></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            sizeInput.map((item, index) => (
                                                <tr key={index} className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                                    <td><input type="number" name="unit" id="" className=" w-full" onChange={(e) => handleSizeInputChange(e, index)} value={item.unit} /></td>
                                                    <td><input type="number" name="price" id="" className=" w-full" onChange={(e) => handleSizeInputChange(e, index)} value={item.price} /></td>
                                                    <td><input type="number" name="stock" id="" className=" w-full" onChange={(e) => handleSizeInputChange(e, index)} value={item.stock} /></td>
                                                    <td onClick={() => deleteSizeInput(index)} className=" cursor-pointer hover:text-red-500"><FaRegTrashAlt /></td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                                <div onClick={addSizeInput} className=" flex gap-2 items-center justify-center py-4 text-gray-500 font-semibold cursor-pointer hover:text-black"><IoIosAddCircleOutline /> Add Variant</div>
                            </div>
                        }
                        {
                            (currentSizeType === sizeType.litre) &&
                            <div className="">
                                <table className=" w-full">
                                    <thead>
                                        <tr className=" text-sm font-semibold text-gray-500 border-b-2 border-slate-300">
                                            <td>Unit (Litres)</td>
                                            <td>Price (&#8358;)</td>
                                            <td>Stock</td>
                                            <td></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            sizeInput.map((item, index) => (
                                                <tr key={index} className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                                    <td><input type="number" name="unit" id="" className=" w-full" onChange={(e) => handleSizeInputChange(e, index)} value={item.unit} /></td>
                                                    <td><input type="number" name="price" id="" className=" w-full" onChange={(e) => handleSizeInputChange(e, index)} value={item.price} /></td>
                                                    <td><input type="number" name="stock" id="" className=" w-full" onChange={(e) => handleSizeInputChange(e, index)} value={item.stock} /></td>
                                                    <td onClick={() => deleteSizeInput(index)} className=" cursor-pointer hover:text-red-500"><FaRegTrashAlt /></td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                                <div onClick={addSizeInput} className=" flex gap-2 items-center justify-center py-4 text-gray-500 font-semibold cursor-pointer hover:text-black"><IoIosAddCircleOutline /> Add Variant</div>
                            </div>
                        }
                        {
                            (currentSizeType === sizeType.cloth) &&
                            <div className="">
                                <table className=" w-full">
                                    <thead>
                                        <tr className=" text-sm font-semibold text-gray-500 border-b-2 border-slate-300">
                                            <td>Size</td>
                                            <td>Price (&#8358;)</td>
                                            <td>Stock</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                            <td>XS</td>
                                            <td><input type="number" name="xs_price" id="" className=" w-full" onChange={handleInputChange} value={inputs.xs_price ?? ''} /></td>
                                            <td><input type="number" name="xs_stock" id="" className=" w-full" onChange={handleInputChange} value={inputs.xs_stock ?? ''} /></td>
                                        </tr>
                                        <tr className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                            <td>S</td>
                                            <td><input type="number" name="s_price" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_price ?? ''} /></td>
                                            <td><input type="number" name="s_stock" id="" className=" w-full" onChange={handleInputChange}  value={inputs.s_stock ?? ''} /></td>
                                        </tr>
                                        <tr className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                            <td>M</td>
                                            <td><input type="number" name="m_price" id="" className=" w-full" onChange={handleInputChange}  value={inputs.m_price ?? ''} /></td>
                                            <td><input type="number" name="m_stock" id="" className=" w-full" onChange={handleInputChange}  value={inputs.m_stock ?? ''} /></td>
                                        </tr>
                                        <tr className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                            <td>L</td>
                                            <td><input type="number" name="l_price" id="" className=" w-full" onChange={handleInputChange} value={inputs.l_price ?? ''} /></td>
                                            <td><input type="number" name="l_stock" id="" className=" w-full" onChange={handleInputChange} value={inputs.l_stock ?? ''} /></td>
                                        </tr>
                                        <tr className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                            <td>XL</td>
                                            <td><input type="number" name="xl_price" id="" className=" w-full" onChange={handleInputChange} value={inputs.xl_price ?? ''} /></td>
                                            <td><input type="number" name="xl_stock" id="" className=" w-full" onChange={handleInputChange}  value={inputs.xl_stock ?? ''} /></td>
                                        </tr>
                                        <tr className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                            <td>XXL</td>
                                            <td><input type="number" name="xxl_price" id="" className=" w-full" onChange={handleInputChange} value={inputs.xxl_price ?? ''} /></td>
                                            <td><input type="number" name="xxl_stock" id="" className=" w-full" onChange={handleInputChange} value={inputs.xxl_stock ?? ''} /></td>
                                        </tr>
                                        <tr className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                            <td>XXXL</td>
                                            <td><input type="number" name="xxxl_price" id="" className=" w-full" onChange={handleInputChange} value={inputs.xxxl_price ?? ''} /></td>
                                            <td><input type="number" name="xxxl_stock" id="" className=" w-full" onChange={handleInputChange} value={inputs.xxxl_stock ?? ''} /></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        }
                        {
                            (currentSizeType === sizeType.shoe) &&
                            <div className="">
                                <table className=" w-full">
                                    <thead>
                                        <tr className=" text-sm font-semibold text-gray-500 border-b-2 border-slate-300">
                                            <td>Size</td>
                                            <td>Price (&#8358;)</td>
                                            <td>Stock</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                            <td>0 - 4</td>
                                            <td><input type="number" name="s_0_4_price" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_0_4_price ?? ''} /></td>
                                            <td><input type="number" name="s_0_4_stock" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_0_4_stock ?? ''} /></td>
                                        </tr>
                                        <tr className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                            <td>5 - 9</td>
                                            <td><input type="number" name="s_5_9_price" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_5_9_price ?? ''} /></td>
                                            <td><input type="number" name="s_5_9_stock" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_5_9_stock ?? ''} /></td>
                                        </tr>
                                        <tr className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                            <td>10 - 14</td>
                                            <td><input type="number" name="s_10_14_price" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_10_14_price ?? ''} /></td>
                                            <td><input type="number" name="s_10_14_stock" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_10_14_stock ?? ''} /></td>
                                        </tr>
                                        <tr className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                            <td>15 - 19</td>
                                            <td><input type="number" name="s_15_19_price" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_15_19_price ?? ''} /></td>
                                            <td><input type="number" name="s_15_19_stock" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_15_19_stock ?? ''} /></td>
                                        </tr>
                                        <tr className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                            <td>20 - 24</td>
                                            <td><input type="number" name="s_20_24_price" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_20_24_price ?? ''} /></td>
                                            <td><input type="number" name="s_20_24_stock" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_20_24_stock ?? ''} /></td>
                                        </tr>
                                        <tr className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                            <td>25 - 29</td>
                                            <td><input type="number" name="s_25_29_price" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_25_29_price ?? ''} /></td>
                                            <td><input type="number" name="s_25_29_stock" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_25_29_stock ?? ''} /></td>
                                        </tr>
                                        <tr className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                            <td>30 - 34</td>
                                            <td><input type="number" name="s_30_34_price" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_30_34_price ?? ''} /></td>
                                            <td><input type="number" name="s_30_34_stock" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_30_34_stock ?? ''} /></td>
                                        </tr>
                                        <tr className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                            <td>35 - 39</td>
                                            <td><input type="number" name="s_35_39_price" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_35_39_price ?? ''} /></td>
                                            <td><input type="number" name="s_35_39_stock" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_35_39_stock ?? ''} /></td>
                                        </tr>
                                        <tr className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                            <td>40 - 44</td>
                                            <td><input type="number" name="s_40_44_price" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_40_44_price ?? ''} /></td>
                                            <td><input type="number" name="s_40_44_stock" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_40_44_stock ?? ''} /></td>
                                        </tr>
                                        <tr className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                            <td>45 - 49</td>
                                            <td><input type="number" name="s_45_49_price" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_45_49_price ?? ''} /></td>
                                            <td><input type="number" name="s_45_49_stock" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_45_49_stock ?? ''} /></td>
                                        </tr>
                                        <tr className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                            <td>50 - 54</td>
                                            <td><input type="number" name="s_50_54_price" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_50_54_price ?? ''} /></td>
                                            <td><input type="number" name="s_50_54_stock" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_50_54_stock ?? ''} /></td>
                                        </tr>
                                        <tr className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                            <td>55 - 59</td>
                                            <td><input type="number" name="s_55_59_price" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_55_59_price ?? ''} /></td>
                                            <td><input type="number" name="s_55_59_stock" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_55_59_stock ?? ''} /></td>
                                        </tr>
                                        <tr className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                            <td>60 - 64</td>
                                            <td><input type="number" name="s_60_64_price" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_60_64_price ?? ''} /></td>
                                            <td><input type="number" name="s_60_64_stock" id="" className=" w-full" onChange={handleInputChange} value={inputs.s_60_64_stock ?? ''} /></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        }
                        {
                            (currentSizeType === sizeType.inches) &&
                            <div className="">
                                <table className=" w-full">
                                    <thead>
                                        <tr className=" text-sm font-semibold text-gray-500 border-b-2 border-slate-300">
                                            <td>Unit (Inches)</td>
                                            <td>Price (&#8358;)</td>
                                            <td>Stock</td>
                                            <td></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            sizeInput.map((item, index) => (
                                                <tr key={index} className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                                    <td><input type="number" name="unit" id="" className=" w-full" onChange={(e) => handleSizeInputChange(e, index)} value={item.unit} /></td>
                                                    <td><input type="number" name="price" id="" className=" w-full" onChange={(e) => handleSizeInputChange(e, index)} value={item.price} /></td>
                                                    <td><input type="number" name="stock" id="" className=" w-full" onChange={(e) => handleSizeInputChange(e, index)} value={item.stock} /></td>
                                                    <td onClick={() => deleteSizeInput(index)} className=" cursor-pointer hover:text-red-500"><FaRegTrashAlt /></td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                                <div onClick={addSizeInput} className=" flex gap-2 items-center justify-center py-4 text-gray-500 font-semibold cursor-pointer hover:text-black"><IoIosAddCircleOutline /> Add Variant</div>
                            </div>
                        }
                        {
                            (currentSizeType === sizeType.capacity) &&
                            <div className="">
                                <table className=" w-full">
                                    <thead>
                                        <tr className=" text-sm font-semibold text-gray-500 border-b-2 border-slate-300">
                                            <td>Unit</td>
                                            <td>Price (&#8358;)</td>
                                            <td>Stock</td>
                                            <td></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            sizeInput.map((item, index) => (
                                                <tr key={index} className=" *:py-2 *:pr-2 border-b-2 border-slate-300">
                                                    <td><input type="number" name="unit" id="" className=" w-full" onChange={(e) => handleSizeInputChange(e, index)} value={item.unit} /></td>
                                                    <td><input type="number" name="price" id="" className=" w-full" onChange={(e) => handleSizeInputChange(e, index)} value={item.price} /></td>
                                                    <td><input type="number" name="stock" id="" className=" w-full" onChange={(e) => handleSizeInputChange(e, index)} value={item.stock} /></td>
                                                    <td onClick={() => deleteSizeInput(index)} className=" cursor-pointer hover:text-red-500"><FaRegTrashAlt /></td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                                <div onClick={addSizeInput} className=" flex gap-2 items-center justify-center py-4 text-gray-500 font-semibold cursor-pointer hover:text-black"><IoIosAddCircleOutline /> Add Variant</div>
                            </div>
                        }
                    </div>
                </div>
                {
                    (currentSizeType === sizeType.kg || currentSizeType === sizeType.litre || currentSizeType === sizeType.inches || currentSizeType === sizeType.capacity) &&
                    <div className=" font-semibold">Total stock: {sizeInput.reduce((n, { stock }) => +n + +stock, 0)}</div>
                }
                {
                    (currentSizeType === sizeType.cloth) &&
                    <div className=" font-semibold">Total stock: {+(inputs.xs_stock ?? 0) + +(inputs.s_stock ?? 0) + +(inputs.m_stock ?? 0) + +(inputs.l_stock ?? 0) + +(inputs.xl_stock ?? 0) + +(inputs.xxl_stock ?? 0) + +(inputs.xxxl_stock ?? 0)}</div>
                }
                {
                    (currentSizeType === sizeType.shoe) &&
                    <div className=" font-semibold">Total stock: {+(inputs.s_0_4_stock ?? 0) + +(inputs.s_5_9_stock ?? 0) + +(inputs.s_10_14_stock ?? 0) + +(inputs.s_15_19_stock ?? 0) + +(inputs.s_20_24_stock ?? 0) + +(inputs.s_25_29_stock ?? 0) + +(inputs.s_30_34_stock ?? 0) + +(inputs.s_35_39_stock ?? 0) + +(inputs.s_40_44_stock ?? 0) + +(inputs.s_45_49_stock ?? 0) + +(inputs.s_50_54_stock ?? 0) + +(inputs.s_55_59_stock ?? 0) + +(inputs.s_60_64_stock ?? 0)}</div>
                }
                
                <button className=" w-full bg-tripstore-black text-white" type="submit">Save Product</button>
            </form>
        </div>
    )
}

export default AddProduct

const sizeType = {
    kg: 'kg',
    litre: 'litre',
    cloth: 'cloth',
    shoe: 'shoe',
    inches: 'inches',
    capacity: 'capacity'
}